import asideModalDisplayed from '@/frontapp/components/AsideModal/AsideModalContext'

export default {
  computed: {
    asideModalDisplayed() {
      return asideModalDisplayed.value
    }
  }
}
